export default "__VITE_ASSET__C_XNnf0z__"